<template>
  <div class="section-main__warp inspection-wrap">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="search_recordTime">
        <div>
          <el-date-picker
            type="datetime"
            placeholder="请选择开始时间"
            v-model="recordStartTime"
            default-time="00:00:00"
            style="width: 182px"
          ></el-date-picker>
          <span style="padding: 0 5px">至</span>
          <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="recordEndTime"
            default-time="23:59:59"
            style="width: 182px"
          ></el-date-picker>
        </div>
      </template>
      <template slot="export">
        <el-button
          type="primary"
          v-auth="'/carspeed/speedRecord:export'"
          :disabled="exportDisabled"
          @click="exportFile"
          class="exportbtn"
          >导出</el-button
        >
        <span class="export-tips" v-show="exportDisabled">正在导出</span>
      </template>
      <template slot="vehicleCode" slot-scope="scope">
        <span
          style="cursor: pointer"
          @click="handleView(scope.row, scope.index)"
        >
          {{ scope.row.vehicleCode }}</span
        >
      </template>
    </ioc-table>
  </div>
</template>
<script>
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../const/recordOption";
import { Dates, Bus, Dic, Cache } from "$utils";
export default {
  components: {},
  data() {
    return {
      exportDisabled: false,
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchParams: {},
      recordStartTime: "",
      recordEndTime: "",
      option: tableOption(this),
    };
  },
  mounted() {
    this.getList();
  },
  created() {
    // 从路由判断 1配置 2详情
    if (this.$route.query) {
      this.searchParams.taskName = this.$route.query.taskName;
    }
  },
  methods: {
    handleSearchReset() {
      this.recordStartTime = "";
      this.recordEndTime = "";
      this.getList();
    },
    getList() {
      const params = {
        taskName: this.searchParams.taskName,
        vehicleCode: this.searchParams.vehicleCode,
        overSpeedStatus: this.searchParams.overSpeedStatus,
        securityWorkGroupNames: this.searchParams.securityWorkGroupNames, //暂定10-11所属中队
        startTime: this.recordStartTime,
        endTime: this.recordEndTime,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        securityWorkGroupName: this.searchParams.securityWorkGroupNames,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.measurespeed.queryOverSpeedRecordList, params).then(
        (response) => {
          setTimeout(() => {
            loading.close();
          }, 500);
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.tableData = response.returnObj
              ? Object.freeze([...response.returnObj.list])
              : [];
            this.page.total = response.returnObj ? response.returnObj.total : 0;
            this.$refs.crud.selectClear();
          }
        }
      );
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSearchChange(param) {
      this.recordStartTime
        ? (this.recordStartTime = Dates.format(this.recordStartTime))
        : "";
      this.recordEndTime
        ? (this.recordEndTime = Dates.format(this.recordEndTime))
        : "";
      this.searchParams = param;
      this.page.currentPage = 1;
      this.getList();
    },
    //导出
    exportFile(data) {
      const params = {
        taskName: data.taskName,
        vehicleCode: data.vehicleCode,
        overSpeedStatus: data.overSpeedStatus,
        startTime: this.recordStartTime
          ? Dates.format(this.recordStartTime)
          : "",
        endTime: this.recordEndTime ? Dates.format(this.recordEndTime) : "",
      };
      if (this.tableData.length < 1) {
        this.$message.warning("暂无数据！");
        return;
      }
      // 兼容IE
      this.exportDisabled = true;
      this.$fetchDownLoad(api.measurespeed.exportOverSpeedRecordList, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          const fileName =
            "超速记录信息" +
            Dates.format(Date.now(), "yyyyMMddHHmmssms") +
            ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
        this.exportDisabled = false;
      });
    },
    handleView(row, index) {
      this.$refs.crud.rowView(row, index);
    },
  },
};
</script>
<style lang="scss">
@import "../style/speed.scss";
</style>
